import React from 'react';

export type SupportDiagnosticPhase = 'idle' | 'dialog' | 'recording' | 'submitting';

export type SupportDiagnosticContextValue = {
  phase: SupportDiagnosticPhase;
  secondsLeft: number;
  openDialog: () => void;
  closeDialog: () => void;
  startRecording: () => void;
  cancelRecording: () => void;
  submitNow: () => void;
};

export const SupportDiagnosticContext = React.createContext<SupportDiagnosticContextValue | null>(null);

export function useSupportDiagnostic(): SupportDiagnosticContextValue {
  const ctx = React.useContext(SupportDiagnosticContext);
  if (!ctx) {
    throw new Error('useSupportDiagnostic must be used within DiagnosticProvider');
  }
  return ctx;
}

/** Safe hook for optional UI (returns null if provider missing). */
export function useSupportDiagnosticOptional(): SupportDiagnosticContextValue | null {
  return React.useContext(SupportDiagnosticContext);
}
